import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  tone?: 'light' | 'dark';
}
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  const isDark = tone === 'dark';
  return <div className="flex items-start gap-1.5 sm:gap-3" data-id="element-61" data-mp="3c0unla60qs8y">
      {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-62" data-mp="3h18wsvjcw88k" data-mpi={i}>
          {i > 0 && <span className={['pt-2.5 font-display text-xl font-semibold sm:pt-3 sm:text-3xl', isDark ? 'text-paper/40' : 'text-ink-muted/50'].join(' ')} aria-hidden="true" data-id="element-63" data-mp="323pyp2ksgiog">
              :
            </span>}
          <div className={['w-[3.75rem] rounded-xl border px-2 py-2.5 text-center sm:w-20 sm:py-3', isDark ? 'border-paper/15 bg-paper/5' : 'border-line bg-surface'].join(' ')} data-id="element-64" data-mp="15b6asfxbgjxb">
            <span className={['block font-display text-xl font-semibold tabular-nums sm:text-3xl', isDark ? 'text-paper' : 'text-ink'].join(' ')} data-id="element-65" data-mp="t1ahbbxaagbo">
              {unit.value}
            </span>
            <span className={['mt-1 block text-[9px] font-semibold uppercase tracking-[0.14em] sm:text-[10px]', isDark ? 'text-paper/60' : 'text-ink-muted'].join(' ')} data-id="element-66" data-mp="f1sngi54scvg">
              {unit.label}
            </span>
          </div>
        </React.Fragment>)}
    </div>;
}